module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEyIiB3aWR0aD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2Utd2lkdGg9IjFwdCI+CiAgICA8cGF0aCBkPSJNMCAwaDE3MC42NjR2NTEyLjAxSDB6Ii8+CiAgICA8cGF0aCBmaWxsPSIjZmZkOTBjIiBkPSJNMTcwLjY2NCAwaDE3MC42NjR2NTEyLjAxSDE3MC42NjR6Ii8+CiAgICA8cGF0aCBmaWxsPSIjZjMxODMwIiBkPSJNMzQxLjMyOCAwaDE3MC42NjV2NTEyLjAxSDM0MS4zMjh6Ii8+CiAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/be.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/be.svg
// module chunks = 0